<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'landmarksCrud'"
          :crudName="$t('Landmarks')"
          :newText="'Novo Ponto de Referência'"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "landmarksTable",
      showMessageImport: false,
      landmarksCrud: {},
      pages: [],
      url: "",
      columns: ["id", "destino_id", "destino_nome", "destino_situacao", "destino_endereco", "landmark_type", "actions"],
      tableData: ["id","destino_id","destino_nome", "destino_situacao", "destino_endereco", "tipo_destino_id"],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["destino_id","destino_nome", "destino_situacao",'destino_endereco', "landmark_type"],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("id"),
          destino_nome: this.$t("Name"),
          situation: this.$t("Situation"),
          address: this.$t("Address"),
          landmark_type: this.$t("Type"),
          actions: this.$t("action"),
        },

        texts: {
          filterBy: this.$t("Filter"),
          defaultOption: this.$t("Select"),
        },
        listColumns: {
          destino_situacao: [
            {
              id: 0,
              text: this.$t('Inactive'),
            },
            {
              id: 1,
              text: this.$t('Active'),
            },
          ],
        },
        templates: {
          landmark_type: function (h, row, index) {
            return row.landmark_type ? row.landmark_type.name : "Sem Nome";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["landmarkType"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "landmarks",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t("id"),
        destino_nome: this.$t("Name"),
        destino_situacao: this.$t("Situation"),
        destino_endereco: this.$t("Address"),
        landmark_type: this.$t("Type"),
        actions: this.$t("action"),
      };

      const texts = {
        filterBy: this.$t("Filter"),
        defaultOption: this.$t("Select"),
      };
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      };
    },
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        destino_id: "destino_id",
        destino_nome: "destino_nome",
        destino_situacao: "destino_situacao",
        destino_endereco: "destino_endereco",
        landmark_type: "landmarkType[name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
